<div class="container">
  <mic-breadcrumb id="casing-size-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('casingSizeText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <div class="casing-size-header">
    <h2 class="page-title casing-size-heading" id="casing-size-heading">{{ translationService.translate('casingSizeText') }}</h2>
    <div class="action-bar">
      <button
        id="reset-filters"
        type="button"
        mat-flat-button
        color="accent"
        class="btn-clear casing-size-action-button"
        (click)="clearFilters()"
      >
        <mat-icon>refresh</mat-icon>
        {{ translationService.translate('clearSelectionText') }}
      </button>
      <span
        [matTooltip]="
          productSaveDisabled
            ? this.translationService.translate('comingSoonText')
            : !saveEnabled
            ? this.translationService.translate('userCannotSaveText')
            : !isModified
            ? this.translationService.translate('noModifiedText')
            : null
        "
        matTooltipPosition="above"
      >
        <button
          id="save"
          type="button"
          mat-flat-button
          color="primary"
          class="btn-primary casing-size-action-button"
          (click)="save()"
          [disabled]="!saveEnabled || !isModified"
        >
          <mat-icon>save</mat-icon>
          {{ translationService.translate('saveLinkText') }}
        </button>
      </span>
      <button mat-flat-button color="primary" class="btn-export casing-size-action-button" (click)="openExportModal()">
        <mat-icon>download</mat-icon>
        {{ translationService.translate('exportButtonText') }}
      </button>
    </div>
  </div>

  <mat-card class="casing-size-filter-card">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <mic-dropdown-search
          micDropdownAccessibility
          [data]="sizeList"
          formControlName="size"
          placeholder="{{ translationService.translate('selectSizeText') }}"
          label="{{ translationService.translate('sizeText') }}"
          [multiple]="true"
          [widthConfig]="{ width: '100%' }"
          subscriptSizing="dynamic"
        ></mic-dropdown-search>
        <mic-dropdown-search
          micDropdownAccessibility
          [data]="descriptionList"
          [widthConfig]="{ width: '100%' }"
          formControlName="description"
          [label]="translationService.translate('descriptionText')"
          placeholder="{{ translationService.translate('SearchByDescriptionText') }}"
          [multiple]="true"
          subscriptSizing="dynamic"
        ></mic-dropdown-search>
        <app-spec-dropdown
          [id]="'constructionId'"
          [options]="constructionList"
          [formGroup]="filterForm"
          [controlName]="'construction'"
          [label]="translationService.translate('constructionText')"
          [editMode]="true"
          [placeholder]="'Select ' + translationService.translate('constructionText')"
        ></app-spec-dropdown>
      </div>
    </form>
  </mat-card>

  <div id="finished-product-table" class="cam-table btn-table table-container">
    <div class="table-wrapper">
      <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>
        <ng-container *micTableColumnSelector>
          <button mat-flat-button [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
            <mat-icon>view_column</mat-icon> {{ translationService.translate('columnsButtonText') }}
          </button>
          <mat-menu #colMenu="matMenu">
            <div class="column-menu-content">
              @for (key of columnKeys; track key) {
              <div>
                <mat-checkbox
                  [checked]="columnVisibility[key]"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                  (change)="toggleColumn(key)"
                  >{{ columnNames[key] || key }}</mat-checkbox
                >
              </div>
              }
            </div>
          </mat-menu>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'stockCasingDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [widthConfig]="{ width: '100%', maxWidth: '300px' }"
            [virtualScroll]="true"
            [data]="dealerRetreadNoList"
            [formControl]="getControl(item, 'stockCasingPartNumber')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'ccPartDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [widthConfig]="{ width: '100%', maxWidth: '300px' }"
            [virtualScroll]="true"
            [data]="dealerRetreadNoList"
            [formControl]="getControl(item, 'ccPartNumber')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'cpRejectDropdown'">
          <mic-dropdown-search
            micDropdownAccessibility
            emptyPlaceholder="No data found"
            subscriptSizing="dynamic"
            [widthConfig]="{ width: '100%', maxWidth: '300px' }"
            [virtualScroll]="true"
            [data]="dealerRetreadNoList"
            [formControl]="getControl(item, 'cpRejectPartNumber')"
          ></mic-dropdown-search>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'tier'">
          <input
            id="TierInput"
            matInput
            type="number"
            min="0"
            [attr.aria-label]="translationService.translate('tierText')"
            [formControl]="getControl(item, 'tier')"
          />
        </ng-container>
      </mic-table>
    </div>
  </div>

  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
